'use client'

import Link from 'next/link'
import { useState } from 'react'
import { AuthPromptDialog } from '~/components/auth/AuthPromptDialog'

type FacilitatorProfileLinkProps = {
  facilitatorId: string
  isAuthenticated?: boolean
  href?: string
  className?: string
  children: React.ReactNode
  stopPropagation?: boolean
}

export function FacilitatorProfileLink({
  facilitatorId,
  isAuthenticated = true,
  href,
  className,
  children,
  stopPropagation = false,
}: FacilitatorProfileLinkProps) {
  const [showAuthPrompt, setShowAuthPrompt] = useState(false)
  const targetHref = href ?? `/facilitator-profile/${facilitatorId}`

  return (
    <>
      <Link
        href={targetHref}
        className={className}
        onClick={(e) => {
          if (stopPropagation) e.stopPropagation()
          if (!isAuthenticated) {
            e.preventDefault()
            setShowAuthPrompt(true)
          }
        }}
      >
        {children}
      </Link>
      <AuthPromptDialog
        open={showAuthPrompt}
        onOpenChange={setShowAuthPrompt}
        title="View facilitator profiles"
        description="Create your free account to explore the full community of facilitators."
        icon="👥"
      />
    </>
  )
}
